module.exports = __webpack_public_path__ + "img/simplex_gray.31b70db6.png";